export default "__VITE_ASSET__DitQ4AcJ__"